var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBreadcrumbsArr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.89645 7.85355C3.70118 7.65829 3.70118 7.34171 3.89645 7.14645L6.04289 5L3.89645 2.85355C3.70118 2.65829 3.70118 2.34171 3.89645 2.14645C4.09171 1.95118 4.40829 1.95118 4.60355 2.14645L6.92678 4.46967C7.21967 4.76256 7.21967 5.23744 6.92678 5.53033L4.60355 7.85355C4.40829 8.04882 4.09171 8.04882 3.89645 7.85355Z",
    fill: "#5C5E62"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreadcrumbsArr);
export default ForwardRef;